import { FilterBase } from './FilterBase'
import { DebugType } from '@/enum/DebugType'


export class FilterDebug extends FilterBase {
        
    public debugTypes:Array<DebugType>
    
    constructor({debugTypes = [] as Array<DebugType>,...args} = {}) { 
        super(args)       
        this.debugTypes = debugTypes
    }
}
